<template>
	<div class="kStep" v-if="stepinfo.step_info.step_list && stepinfo.step_info.step_list.length>0">
		<el-steps :active="stepinfo.step_info.now_step" finish-status="success">
		  <el-step v-for="(item,index) in stepinfo.step_info.step_list" :key="index">
			<template slot="title">
			  <el-popover width="300" trigger="hover" placement="bottom-end" v-if="item.log_list.check_name">
				  <ul class="ul">
					  <li>
						 {{item.log_list.check_name}}
					  </li>
					  <li>
					  	 {{item.log_list.check_time}}
					  </li>
					  <li>
					  	 {{item.log_list.check_content}}
					  </li>
				  </ul>
				<span slot="reference" class="li">{{item.step_name}}</span>
			  </el-popover>
			  <span slot="reference" class="li" v-else>{{item.step_name}}</span>
			</template>
		  </el-step>
		</el-steps>
	</div>
</template>

<script>
export default {
  name: 'step',
  props: ['stepinfo'],
  data() {
    return {
    }
  },
  mounted: function () {
  },
  methods: {
    
  }
}
</script>
<style scoped lang="scss">
.ul{
	padding: 10px 20px;
	line-height: 20px;
	width: 100%;
	box-sizing: border-box;
}
</style>
